<template>
  <div class="indexBg"></div>
</template>
<script>
export default {
  name: "indexPage",
  data() {
    return {};
  },
  async created() {
    // 解析 URL 参数并存储到 Vuex，然后根据 type 跳转
    const { unionId, type } = this.parseQueryParams();

    // 根据 type 跳转
    if (type === "help1") {
      this.$router.replace("/help1");

    } else if (type === "help2") {
      this.$router.replace("/help2");
    } else if (type === "help3") {
      this.$router.replace("/help3");
    } else if (type === "help4") {
      this.$router.replace("/help4");
    } else if (type === "help5") {
      this.$router.replace("/help5");
    } else if (type === "help6") {
      this.$router.replace("/help6");
    } 
  },
  mounted() {},

  methods: {
    parseQueryParams() {
      const search = window.location.search || "";
      const queryString = search.startsWith("?") ? search.substring(1) : search;
      const params = {};
      queryString.split("&").forEach((pair) => {
        if (!pair) return;
        const [rawKey, rawValue] = pair.split("=");
        const key = decodeURIComponent(rawKey || "");
        const value = decodeURIComponent(rawValue || "");
        if (key) params[key] = value;
      });
      return params;
    },
  },
};
</script>

<style scoped lang="less"></style>
